import { Text, Title } from "@clipboard-health/ui-components";
import { isIosPlatform } from "@src/appV2/lib/utils/capacitor/platformUtils";

export function ScanTimeoutContent(): JSX.Element {
  const isIOS = isIosPlatform();

  return (
    <>
      <Title variant="h2" component="h1">
        Tag not detected
      </Title>

      <Text bold>We couldn’t detect a signal from the NFC poster.</Text>
      <Text bold>
        Try removing your phone case or connecting to Wi-Fi. Make sure you&apos;re holding{" "}
        {isIOS ? "the top" : "the back center"} of your phone next to the poster.
      </Text>
    </>
  );
}
